import { Intent } from "@blueprintjs/core";
import { useBulkArchiveScenarios } from "in_queue/hooks/useBulkArchiveScenarios";
import { ScenarioMetadata } from "in_queue/types/scenarioType";
import {
    ScenarioArchiveAlert,
    ScenarioArchiveToaster
} from "./ScenarioArchiveAlert";

export const BulkArchiveScenariosAlert: React.FC<{
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    scenarios: ReadonlyArray<ScenarioMetadata>;
    projectId: string;
    onArchived: () => void;
}> = ({ isOpen, setIsOpen, scenarios, projectId, onArchived }) => {
    const { archiveScenarios, isArchiving } = useBulkArchiveScenarios({
        projectId
    });

    const confirm = async () => {
        const result = await archiveScenarios(scenarios).catch(() => undefined);

        if (result === undefined) {
            ScenarioArchiveToaster.show({
                intent: Intent.DANGER,
                message: "Couldn't archive scenarios. Please try again."
            });
            setIsOpen(false);
            return;
        }

        if (result.archivedCount === 0) {
            ScenarioArchiveToaster.show({
                intent: Intent.WARNING,
                message: "No scenarios were archived."
            });
            setIsOpen(false);
            return;
        }

        ScenarioArchiveToaster.show({
            intent: Intent.SUCCESS,
            message:
                result.archivedCount === result.requestedCount
                    ? `Archived ${result.archivedCount} ${
                          result.archivedCount === 1 ? "scenario" : "scenarios"
                      }`
                    : `Archived ${result.archivedCount} of ${result.requestedCount} scenarios`
        });
        setIsOpen(false);
        onArchived();
    };

    return (
        <ScenarioArchiveAlert
            action="archive"
            count={scenarios.length}
            isOpen={isOpen}
            isLoading={isArchiving}
            onCancel={() => setIsOpen(false)}
            onConfirm={confirm}
        />
    );
};
